import { useState } from 'react';
import { Icon } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import CreditRatingModal from '@app/components/popups/CreditRatingModal';
const CreditScoreLabelMobile = () => {
    const { t } = useTranslation();
    const [isCreditRatingModalOpen, setIsCreditRatingModalOpen] = useState(false);
    return (<>
            {t('financing.investing_page_table.credit_score')}
            <button type="button" onClick={() => setIsCreditRatingModalOpen(true)} className="text-gray-400 hover:text-gray-600 cursor-pointer" aria-label={t('financing.credit_rating.modal_title')}>
                <Icon name="info_filled" size="sm"/>
            </button>
            <CreditRatingModal isOpen={isCreditRatingModalOpen} closeModal={() => setIsCreditRatingModalOpen(false)}/>
        </>);
};
export default CreditScoreLabelMobile;
